import { connect } from 'react-redux';
import { compose } from 'recompose';

import TimesheetNav from './TimesheetNav';
import { queryPastTimesheetsGQL } from '../graphql';
import { setSelectedTimesheetDateThunk } from '../actions';
import { getUserTimeZone } from '../../authentication/selectors';
import { getCurrentSelectedUserId, getCurrentSelectedTimesheetDateString, getSelectTimeEntryDateString } from '../selectors';

const mapStateToProps = (state) => {
  return {
    userId: getCurrentSelectedUserId(state),
    originDate: getSelectTimeEntryDateString(state),
    currentSelectedTimesheetDate: getCurrentSelectedTimesheetDateString(state),
    periods: 5,
    timeZone: getUserTimeZone(state),
  };
};

const mapDispatchToProps = {
  dispatchSelectTimesheetDate: setSelectedTimesheetDateThunk,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  queryPastTimesheetsGQL,
);

export default enhance(TimesheetNav);
